import { render, staticRenderFns } from "./DateElement.vue?vue&type=template&id=f47c1744&scoped=true&"
import script from "./DateElement.vue?vue&type=script&lang=js&"
export * from "./DateElement.vue?vue&type=script&lang=js&"
import style0 from "./DateElement.vue?vue&type=style&index=0&id=f47c1744&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47c1744",
  null
  
)

export default component.exports